hoverDirectiveModule = angular.module('hover.setting', [])

hoverDirectiveModule.directive "hoverSetting", ["$window", "$timeout", "$compile", "$templateCache", ($window, $timeout, $compile, $templateCache) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/hover/template.jade"
  link: (scope, element, attrs, ngModel) ->

    scope.accessKey = attrs.accessKey
    widgetId = scope.data.id
    scope.buttonType = attrs.buttonType

    dasherize = (str) ->
      return str.replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();

    change = (newVal) ->
      css = ""
      switch scope.data.type
        when "button"
          scope.data.button_attributes.hover_style_attributes.backgroundImage = "none"
          hover_style = _.map newVal.button_attributes.hover_style_attributes, (value, key) -> "#{dasherize(key)}:#{value} !important"
          css += ".str-bw_#{widgetId} .strwf_button:hover { #{hover_style.join("; ")}}"
        when "product"
          scope.data.hover_style_attributes.backgroundImage = "none"
          hover_style = _.map newVal.hover_style_attributes, (value, key) -> "#{dasherize(key)}:#{value} !important"
          css += ".str-bw_#{widgetId} .strwcrd__button:hover { #{hover_style.join("; ")}}"
        when "card"
          scope.data.button_attributes.hover_style_attributes.backgroundImage = "none"
          hover_style = _.map newVal.button_attributes.hover_style_attributes, (value, key) -> "#{dasherize(key)}:#{value} !important"
          css += ".str-bw_#{widgetId} .strwcrd__button:hover { #{hover_style.join("; ")}}"
        when "form", "subscribe_form"
          scope.data.parent_button.hover_style.backgroundImage = "none"
          scope.data.button.hover_style.backgroundImage = "none"
          hover_style1 = _.map newVal.parent_button.hover_style, (value, key) -> "#{dasherize(key)}:#{value} !important"
          hover_style2 = _.map newVal.button.hover_style, (value, key) -> "#{dasherize(key)}:#{value} !important"
          css += ".str-bw_#{widgetId} .strwf__parent-button:hover { #{hover_style1.join("; ")}}"
          css += "form[id='#{widgetId}'] .strwf_form-button:hover { #{hover_style2.join("; ")}}"
      scope.data = newVal

      if $("#hover_#{widgetId}").length is 0
        $(".editor").append("<style id='hover_#{widgetId}'>#{css}</style>")
      else
        $("#hover_#{widgetId}").html(css)
    scope.$watch "data", change, true

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/hover/hover.directive.coffee